module.exports = __webpack_public_path__ + "static/media/target.47f51cb2.png";